<template>
  <div>
    <v-card height="100%">
      <v-card-title>
        Linked Tickets
      </v-card-title>

      <v-card-text>
        <v-data-table :headers="headers" :items="getLinkedTickets" hide-default-footer>
          <template v-slot:item.last_changed="{ item }">{{ item.last_changed | formatDate }}</template>
          <template v-slot:item.id="{ item }">
            <a :href="`/tickets/${item.id}/`">{{ item.id }}</a>
          </template>
          <template v-slot:item.freshdesk_id="{ item }">
            <a :href="`${freshdeskTicketsDomain}/${item.freshdesk_id}`" target="_blank">{{ item.freshdesk_id }}</a>
          </template>
          <template v-slot:item.agent="{ item }">{{ item.agent | customPlaceholder }}</template>
          <template v-slot:item.status="{ item }">{{ item.status | customPlaceholder }}</template>
          <template v-slot:item.department="{ item }">{{ item.department | customPlaceholder }}</template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { freshdeskTicketsDomain } from '@/helpers/links';

export default {
  data() {
    return {
      headers: [
        { text: 'Last updated', value: 'last_changed', sortable: false },
        { text: 'CRM Ticket ID', value: 'id', sortable: false },
        { text: 'Freshdesk Ticket ID', value: 'freshdesk_id', sortable: false },
        { text: 'Agent', value: 'agent', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Resolution', value: 'resolution', sortable: false },
      ],
      freshdeskTicketsDomain,
    }
  },

  computed: {
    ...mapGetters('tickets', ['getLinkedTickets']),
  },
};
</script>

<style lang="scss" scoped></style>
